/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceVersionInfo
 */
export interface InvoiceVersionInfo {
    /**
     * 
     * @type {string}
     * @memberof InvoiceVersionInfo
     */
    linkedIdentifier?: string;
}

/**
 * Check if a given object implements the InvoiceVersionInfo interface.
 */
export function instanceOfInvoiceVersionInfo(value: object): value is InvoiceVersionInfo {
    return true;
}

export function InvoiceVersionInfoFromJSON(json: any): InvoiceVersionInfo {
    return InvoiceVersionInfoFromJSONTyped(json, false);
}

export function InvoiceVersionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceVersionInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'linkedIdentifier': json['linkedIdentifier'] == null ? undefined : json['linkedIdentifier'],
    };
}

export function InvoiceVersionInfoToJSON(value?: InvoiceVersionInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'linkedIdentifier': value['linkedIdentifier'],
    };
}

